/* ISOFIN — Shipping-Box Update (Amazon-style "Bestellung innerhalb X" v214 ausgelagert)
   Vorher inline in sections/isofin-startseite.liquid → blockierte Main-Thread mit
   Intl.DateTimeFormat-Initialisierung. Jetzt: defer-loaded, läuft nach DOM-Parse. */
(function () {
  'use strict';
  var CONFIG = {
    TIMEZONE: 'Europe/Berlin',
    CUTOFF_HOUR_LOCAL: 12,
    LABEL_HTML: '<span class="blue">Versand</span>',
    SELECTOR: '.amazon-shipping-box',
    TICK_MS: 30000
  };

  function tzNow(tz) {
    var fmt = new Intl.DateTimeFormat('de-DE', {
      timeZone: tz, hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var p = fmt.formatToParts(new Date());
    function part(t) { return Number(p.find(function (x) { return x.type === t; }).value); }
    return new Date(Date.UTC(part('year'), part('month') - 1, part('day'), part('hour') % 24, part('minute'), part('second')));
  }

  /* 02.10.2026 (Paket 0): gleiche Korrektur wie iso-cart-drawer.js/sec-02 – Do–Sa ab 22/23 Uhr stand „Versand So“. Datumswerte sind Berliner Uhrzeit in UTC-Feldern, deshalb nur getUTC/setUTC und Ausgabe mit timeZone 'UTC'; Schluss 12 Uhr Berlin; Wochenende + Feiertage Niedersachsen. */
  function localCutoffUTCDate(baseUTC, tz, cutoffHourLocal) { var d = new Date(baseUTC); d.setUTCHours(cutoffHourLocal, 0, 0, 0); return d; }

  function weekdayShort(d, tz) {
    return new Intl.DateTimeFormat('de-DE', { weekday: 'short', timeZone: 'UTC' }).format(d).toLowerCase();
  }
  function weekdayLong(d, tz) {
    return new Intl.DateTimeFormat('de-DE', { weekday: 'long', timeZone: 'UTC' }).format(d);
  }
  function dayOfMonth(d, tz) {
    return new Intl.DateTimeFormat('de-DE', { day: 'numeric', timeZone: 'UTC' }).format(d);
  }
  function monthLong(d, tz) {
    return new Intl.DateTimeFormat('de-DE', { month: 'long', timeZone: 'UTC' }).format(d);
  }

  function nextShippingSlot(tz, cutoffHourLocal) {
    var nowTZ = tzNow(tz);
    var shipAt = new Date(nowTZ);
    var todayCutoffUTC = localCutoffUTCDate(nowTZ, tz, cutoffHourLocal);
    function isWeekend(d) { var x = d.getUTCDay(); if (x === 0 || x === 6) return true; var y = d.getUTCFullYear(), md = (d.getUTCMonth() + 1) * 100 + d.getUTCDate(); if (md === 101 || md === 501 || md === 1003 || md === 1031 || md === 1225 || md === 1226) return true; var a = y % 19, b = Math.floor(y / 100), c = y % 100, e = (19 * a + b - Math.floor(b / 4) - Math.floor((b - Math.floor((b + 8) / 25) + 1) / 3) + 15) % 30; var l = (32 + 2 * (b % 4) + 2 * Math.floor(c / 4) - e - (c % 4)) % 7, m = Math.floor((a + 11 * e + 22 * l) / 451), n = e + l - 7 * m + 114; var t = Math.round((Date.UTC(y, d.getUTCMonth(), d.getUTCDate()) - Date.UTC(y, Math.floor(n / 31) - 1, (n % 31) + 1)) / 864e5); return t === -2 || t === 1 || t === 39 || t === 50; }
    if (!isWeekend(nowTZ) && nowTZ < todayCutoffUTC) {
      shipAt = todayCutoffUTC;
    } else {
      shipAt.setUTCDate(shipAt.getUTCDate() + 1);
      while (isWeekend(shipAt)) {
        shipAt.setUTCDate(shipAt.getUTCDate() + 1);
      }
      shipAt = localCutoffUTCDate(shipAt, tz, cutoffHourLocal);
    }
    return { nowTZ: nowTZ, shipAt: shipAt };
  }

  function formatDeltaHHMM(from, to) {
    var ms = Math.max(0, to - from);
    var totalMin = Math.floor(ms / 60000);
    var h = Math.floor(totalMin / 60);
    var m = totalMin % 60;
    return h > 0 ? (h + ' Std.' + (m > 0 ? ' ' + m + ' Min.' : '')) : (m + ' Min.');
  }

  function renderShippingHTML() {
    var slot = nextShippingSlot(CONFIG.TIMEZONE, CONFIG.CUTOFF_HOUR_LOCAL);
    var left = formatDeltaHHMM(slot.nowTZ, slot.shipAt);
    var wd = weekdayLong(slot.shipAt, CONFIG.TIMEZONE);
    var day = dayOfMonth(slot.shipAt, CONFIG.TIMEZONE);
    var mon = monthLong(slot.shipAt, CONFIG.TIMEZONE);
    return CONFIG.LABEL_HTML + ' <strong>' + wd + ', ' + day + '. ' + mon + '</strong>. ' +
      'Bestellung innerhalb <span class="green">' + left + '</span>';
  }

  function updateAllBoxes() {
    var nodes = document.querySelectorAll(CONFIG.SELECTOR);
    if (!nodes.length) return;
    var html = renderShippingHTML();
    nodes.forEach ? nodes.forEach(function (el) { el.innerHTML = html; })
      : Array.prototype.forEach.call(nodes, function (el) { el.innerHTML = html; });
  }

  function boot() { updateAllBoxes(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setInterval(updateAllBoxes, CONFIG.TICK_MS);
})();
